import React from 'react';
import { Search } from 'lucide-react';
const TopBar: React.FC = () => {
  return <div className="h-14 border-b border-gray-200 bg-white flex items-center px-4" data-id="element-345">
      <div className="flex items-center w-1/3" data-id="element-346">
        <div className="relative w-full" data-id="element-347">
          <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" size={16} data-id="element-348" />
          <input type="text" placeholder="Search..." className="w-full pl-9 pr-4 py-1.5 border border-gray-200 rounded text-sm" data-id="element-349" />
        </div>
      </div>
      <div className="flex-1" data-id="element-350"></div>
      <div className="flex items-center" data-id="element-351">
        <div className="h-8 w-8 rounded-full bg-[#0070d2] text-white flex items-center justify-center" data-id="element-352">
          <span className="text-sm font-medium" data-id="element-353">JS</span>
        </div>
      </div>
    </div>;
};
export default TopBar;